export const MAX_CHANNELS = 3;
